/**
 * Mamash Organics — Scroll Reveal
 * Lightweight IntersectionObserver replacement for Framer Motion's whileInView.
 * Add class "scroll-reveal" to any element to animate it in on scroll.
 * Optional: data-delay="100" (ms) for staggered reveals.
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) {
    // Fallback: just make everything visible
    document.querySelectorAll('.scroll-reveal').forEach((el) => {
      el.classList.add('is-visible');
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const delay = parseInt(el.dataset.delay || '0', 10);
        setTimeout(() => el.classList.add('is-visible'), delay);
        observer.unobserve(el);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('.scroll-reveal').forEach((el) => observer.observe(el));
})();
